export default __webpack_public_path__ + "static/media/Group1268-tata-neu@2x.0e1c09e0.png";